<script>
    import { Link } from 'svelte-navigator';

    export let lang = 'en';
</script>

<section
    class="grid w-full px-0 py-32 text-lg text-white bg-blue-100 xl:px-40 md:px-20 sm:px-10"
    style="
background-image: url(/img/svg/zigzag.svg);
background-position: center;
background-size:cover;
background-repeat: no-repeat;"
>
    <img
        class="h-20 mb-10 lg:mb-20 place-self-center"
        src={lang === 'bg' ? '/img/svg/logo-bg.svg' : '/img/svg/logo-en.svg'}
        alt="Inner Voice"
    />

    <img
        class="h-32 max-w-full place-self-center"
        src={lang === 'bg' ? '/img/svg/404.svg' : '/img/svg/404.svg'}
        alt="404"
    />
    <h1 class="my-6 text-center sm:text-heading text-lg-subheading">
        {#if lang == 'bg'}
            Хей, изглежда страницата, която търсиш, не може да бъде открита.
        {:else}
            Hey, it seems the page you're looking for can't be found.
        {/if}
    </h1>

    <h3 class="mb-6 text-base text-center md:w-5/6 md:block place-self-center">
        {#if lang == 'bg'}
            Много мразим като стане така... Изпращаме нашите тренирани следотърсачи по следите на
            страницата, а ти можеш да се върнеш към познатото.
        {:else}
            We really hate it when that happens... Sending out our best trained investigators after
            the page, meanwhile you can get back to our known locations.
        {/if}
    </h3>

    <Link
        to="/"
        class="p-3 transition-all duration-200 transform button teal-button sm:px-20 sm:py-3 hover:translate-y-1 place-self-center"
    >
        {lang == 'bg' ? 'Заведи ме там' : "Let's go"}
    </Link>
</section>
